module.exports = __webpack_public_path__ + "img/firefox3.7c80bbce.png";